import React from 'react';
import { Button } from '@americanexpress/dls-react';
import { useNavigate } from 'react-router-dom';
import styles from './styles/OCCUnsubscribe.scss';
import FormattedRichMessage from '../common/FormattedRichMessages';

// import { useOCC } from './context/occContext';
// import { updateOccPreferences } from '../../services/occ.service';
import { updatePrivacyPreferences } from '../../services/privacy.service';
// import { decrypt3DES } from '../../utils/occDecrypt';
import useOccEmail from '../../utils/hooks/useOccEmail';
function OCCUnsubscribePage() {
  const navigate = useNavigate();

  // const { params, emailObj, setEmailObj } = useOCC();

  // const [loading, setLoading] = useState(false);

  // Email Decryption & Masking on mount
  const emailObj = useOccEmail();
  // console.log('Email Object from Hook:', emailObj);

  // 🔹 Handlers
  const handleCancel = () => {
    navigate('/occ/surveysresearchNLCancel');
  };
  const handleSave = async () => {
    try {
      if (!(emailObj !== null && emailObj !== void 0 && emailObj.emailAddress)) {
        navigate('/occ/optouterror');
        return;
      }
      const response = await updatePrivacyPreferences({
        emailAddress: emailObj.emailAddress,
        preferenceStatus: 'O'
      });

      // console.log('UPDATE API RESPONSE:', response);

      if (response) {
        navigate('/occ/surveysresearchNLTY');
      } else {
        navigate('/occ/optouterror');
      }
    } catch (error) {
      console.error('UPDATE API ERROR:', error);
      navigate('/occ/optouterror');
    } finally {
      // setSaving(false);
    }
  };

  // 🔹 Loader state
  // if (loading || !emailObj) {
  //   return <div>Loading...</div>;
  // }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.occ_unsubscribe_container
  }, /*#__PURE__*/React.createElement("h1", {
    className: styles.occ_title
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occUnsubscribe.title"
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.occ_subtitle
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occUnsubscribe.subtitle",
    values: {
      email: emailObj === null || emailObj === void 0 ? void 0 : emailObj.maskedEmail
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.occ_description
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occUnsubscribe.description"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.occ_actions
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: handleCancel
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occUnsubscribe.cancelRequest"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: handleSave
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occUnsubscribe.saveChanges"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.occ_info
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occUnsubscribe.note1"
  })), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occUnsubscribe.note1a"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occUnsubscribe.note1b"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occUnsubscribe.note1c"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occUnsubscribe.note1d"
  })))));
}
export default OCCUnsubscribePage;